import React from "react";
import NavBar from "../../components/Navbar";
import SearchList from "../../components/search/SearchList";
import Section from "../../components/Section";
import { useParams } from "react-router-dom";

function Search() {
    const query = useParams();

    return (
        <>
        <NavBar />
        <Section title="Search Results"  >
            <SearchList keyword={query.query} />
        </Section>
        </>
    );

}

export default Search;
